import React from 'react';

const RegeneratePopup = React.memo(({ show, onCancel, onConfirm }) => {
  if (!show) return null;
  
  return (
    <div className="regenerate-popup">
      <p>
        Klicka på <strong>"Generera om"</strong> för att skapa en ny
        journal. Alla ändringar försvinner.
      </p>
      <div className="regenerate-popup-buttons">
        <button
          className="cancel-regenerate-button"
          onClick={onCancel}
        >
          Avbryt
        </button>
        <button
          className="confirm-regenerate-button"
          onClick={onConfirm}
        >
          Generera om
        </button>
      </div>
    </div>
  );
});

RegeneratePopup.displayName = 'RegeneratePopup';

export default RegeneratePopup;